<template>
  <div>
    <main role="main">
      <div id="ScrollSec_1"></div>
      <div class="page-content">
        <div class="container py-md-5 py-4">
          <div v-if="detail.registration_no">
            <div class="row justify-content-center" v-if="!loader">
              <div class="col-lg-10">
                <div class="row align-items-center mb-4">
                  <div class="col-md-6 row">
                    <h2 class="page-title mb-md-0 mb-3">
                      <a class="cursor-pointer" v-on:click="$router.go(-1)"
                        ><img
                          src="/images/back-arrow.svg"
                          width="20"
                          alt=""
                          class="me-2"
                      /></a>
                    </h2>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-3 mb-4" v-if="type == 'SELF'">
                    <div
                      id="suggesteProfileSlider"
                      class="carousel slide suggesteProfileSlider"
                      data-bs-ride="carousel"
                      data-bs-interval="false">
                      <div
                        class="carousel-inner rounded-l cursor-pointer"
                        v-if="detail.user_images.length">
                        <div
                          class="carousel-item mb-3"
                          v-for="(data, index) in detail.user_images"
                          :key="index"
                          :class="index == 0 ? 'active' : ''">
                          <img
                            v-on:click="showUserGallery(index)"
                            :src="data.image ? data.image : 'img/profile.svg'"
                            class="photos" />
                        </div>
                      </div>
                      <img
                        v-if="detail.handPicked"
                        src="/images/sugested-label.svg"
                        alt="Sugested"
                        class="corner-label"
                        width="120"
                        height="121" />
                    </div>
                    <div
                      id="suggesteProfileSlider"
                      class="carousel slide suggesteProfileSlider"
                      data-bs-ride="carousel"
                      data-bs-interval="false"
                      v-if="detail.user_images.length == 0">
                      <div class="carousel-inner rounded-l cursor-pointer">
                        <div class="carousel-item active">
                          <img
                            src="/img/profile.svg"
                            class="photos"
                            alt="..." />
                        </div>
                      </div>
                      <img
                        v-if="detail.handPicked"
                        src="/images/sugested-label.svg"
                        alt="Sugested"
                        class="corner-label"
                        width="120"
                        height="121" />
                    </div>
                    <div
                      class="text-center mb-5 position-relative"
                      v-if="detail.user_images.length > 1">
                      <button
                        class="carousel-control-prev"
                        type="button"
                        data-bs-target="#suggesteProfileSlider"
                        data-bs-slide="prev"
                        v-on:click="PrevIndex()">
                        <span
                          class="carousel-control-prev-icon"
                          aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                      </button>
                      <span
                        >{{ indexCount }}/{{ detail.user_images.length }}</span
                      >
                      <button
                        class="carousel-control-next"
                        type="button"
                        data-bs-target="#suggesteProfileSlider"
                        data-bs-slide="next"
                        v-on:click="NextIndex()">
                        <span
                          class="carousel-control-next-icon"
                          aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                      </button>
                    </div>
                    <!-- <p class="text-brand text-center">
                    Suggested Date: 12/11/2021
                  </p> -->
                    <button
                      v-on:click="showContactModel()"
                      class="btn btn-outline-brand-1 mb-2 w-100">
                      <i class="fa fa-eye font-20 me-2" aria-hidden="true"></i>
                      View Contact
                    </button>
                    <button
                      :disabled="type == 'SELF'"
                      class="btn btn-outline-brand-1 mb-2 w-100">
                      <i
                        class="fa fa-paper-plane font-20 me-2"
                        aria-hidden="true"></i>
                      Send interest
                    </button>
                    <button
                      :disabled="type == 'SELF'"
                      class="btn btn-outline-brand-1 mb-2 w-100">
                      <i
                        class="fa fa-heart font-20 me-2"
                        aria-hidden="true"></i>
                      Shortlist
                    </button>
                    <div v-click-outside="showDropDown" class="dropdown">
                      <button
                        type="button"
                        class="btn btn-outline-brand-1 w-100 dropdown-toggle"
                        id="dropdownMore"
                        @click="
                          this.isClick = true;
                          this.isShowMore = !this.isShowMore;
                        ">
                        <i
                          class="fa fa-ellipsis-v font-20 me-2"
                          aria-hidden="true"></i>
                        More
                      </button>
                      <ul
                        :class="
                          isShowMore == true
                            ? 'dropdown-menu show'
                            : 'dropdown-menu'
                        ">
                        <li>
                          <a
                            class="dropdown-item cursor-pointer"
                            v-on:click="showSharePopup(detail.uuid)"
                            ><i class="fa fa-share-alt" aria-hidden="true"></i>
                            Share Profile</a
                          >
                        </li>
                        <li>
                          <a
                            :disabled="type == 'SELF'"
                            class="dropdown-item cursor-pointer"
                            ><i class="fa fa-ban" aria-hidden="true"></i> Block
                            User</a
                          >
                        </li>
                        <li>
                          <a
                            :disabled="type == 'SELF'"
                            class="dropdown-item cursor-pointer"
                            ><i class="fa fa-ban" aria-hidden="true"></i>
                            Unblock</a
                          >
                        </li>
                        <li>
                          <a
                            :disabled="type == 'SELF'"
                            class="dropdown-item cursor-pointer"
                            ><i class="fa fa-flag" aria-hidden="true"></i>
                            Report This User</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-3 mb-4" v-else>
                    <div
                      id="suggesteProfileSlider"
                      class="carousel slide suggesteProfileSlider"
                      data-bs-ride="carousel"
                      data-bs-interval="false">
                      <div
                        class="carousel-inner rounded-l cursor-pointer"
                        v-if="detail.user_images.length">
                        <div
                          class="carousel-item"
                          v-for="(data, index) in detail.user_images"
                          :key="index"
                          :class="index == 0 ? 'active' : ''">
                          <img
                            v-on:click="showUserGallery(index)"
                            :src="data.image ? data.image : 'img/profile.svg'"
                            class="photos" />
                        </div>
                      </div>
                      <img
                        v-if="detail.handPicked"
                        src="/images/sugested-label.svg"
                        alt="Sugested"
                        class="corner-label"
                        width="120"
                        height="121" />
                    </div>
                    <div
                      id="suggesteProfileSlider"
                      class="carousel slide suggesteProfileSlider mb-2"
                      data-bs-ride="carousel"
                      data-bs-interval="false"
                      v-if="detail.user_images.length == 0">
                      <div class="carousel-inner rounded-l cursor-pointer">
                        <div class="carousel-item active">
                          <img
                            src="/img/profile.svg"
                            class="photos"
                            alt="..." />
                        </div>
                      </div>
                      <img
                        v-if="detail.handPicked"
                        src="/images/sugested-label.svg"
                        alt="Sugested"
                        class="corner-label"
                        width="120"
                        height="121" />
                    </div>
                    <div
                      class="text-center mb-5 position-relative"
                      v-if="detail.user_images.length > 1">
                      <button
                        class="carousel-control-prev"
                        type="button"
                        data-bs-target="#suggesteProfileSlider"
                        data-bs-slide="prev"
                        v-on:click="PrevIndex()">
                        <span
                          class="carousel-control-prev-icon"
                          aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                      </button>
                      <span
                        >{{ indexCount }}/{{ detail.user_images.length }}</span
                      >
                      <button
                        class="carousel-control-next"
                        type="button"
                        data-bs-target="#suggesteProfileSlider"
                        data-bs-slide="next"
                        v-on:click="NextIndex()">
                        <span
                          class="carousel-control-next-icon"
                          aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                      </button>
                    </div>
                    <!-- <p class="text-brand text-center">
                    Suggested Date: 12/11/2021
                  </p> -->
                    <button
                      v-if="!detail.hasViewContact && isShowContactView"
                      v-on:click="showRemmaingtactModel()"
                      class="btn btn-outline-brand-1 mt-2 mb-3 w-100">
                      <i class="fa fa-eye font-20 me-2" aria-hidden="true"></i>
                      View Contact
                    </button>
                    <button
                      v-if="detail.hasViewContact && isShowContactView"
                      v-on:click="showRemmaingtactModel()"
                      class="btn btn-brand-1 mt-2 mb-3 w-100">
                      <i class="fa fa-eye font-20 me-2" aria-hidden="true"></i>
                      View Contact
                    </button>
                    <button
                      v-if="!detail.hasSentIntrest && isShowSendIntrest"
                      type="button"
                      class="btn btn-outline-brand-1 w-100 mb-3"
                      v-on:click="sendIntrest()">
                      <i
                        class="fa fa-paper-plane font-20 me-2"
                        aria-hidden="true"></i>
                      Send interest
                    </button>
                    <button
                      v-if="detail.hasSentIntrest && isShowSendIntrest"
                      type="button"
                      class="btn btn-brand-1 w-100 mb-3"
                      v-on:click="notIntrested()">
                      <i
                        class="fa fa-paper-plane font-20 me-2"
                        aria-hidden="true"></i>
                      Cancel interest
                    </button>
                    <div
                      class="btn-group w-100"
                      role="group"
                      aria-label="Basic checkbox toggle button group"
                      v-if="!detail.hasShortListed && isShowShortListed">
                      <input
                        type="checkbox"
                        class="btn-check"
                        :id="'btncheck' + index"
                        autocomplete="off" />
                      <label
                        class="btn btn-outline-brand-1 mb-3 w-100"
                        :for="'btncheck' + index"
                        v-on:click="shortlist()"
                        ><i
                          class="fa fa-heart font-20 me-2"
                          aria-hidden="true"></i>
                        Shortlist</label
                      >
                    </div>
                    <button
                      v-if="detail.hasShortListed && isShowShortListed"
                      type="button"
                      class="btn btn-brand-1 w-100 mb-3"
                      v-on:click="removeShortlisted()">
                      <i
                        class="fa fa-heart font-20 me-2"
                        aria-hidden="true"></i>
                      Shortlisted
                    </button>
                    <button
                      v-if="detail.hasBlocked && isShowUnblockbtn"
                      type="button"
                      class="btn btn-outline-brand-1 mb-3 w-100"
                      v-on:click="unblockUserBtn()">
                      <i class="fa fa-ban" aria-hidden="true"></i>
                      Unblock
                    </button>
                    <button
                      v-if="detail.hasReported && !isShowReasonbtn"
                      type="button"
                      class="btn btn-outline-brand-1 mb-3 w-100 mt-1"
                      v-on:click="showViewReportedReasonpopup()">
                      <i class="fa fa-question-circle" aria-hidden="true"></i>
                      View Reason
                    </button>
                    <button
                      v-if="isShowReasonbtn"
                      type="button"
                      class="btn btn-outline-brand-1 mb-3 w-100 mt-1"
                      v-on:click="showViewRejectpopup()">
                      <i class="fa fa-question-circle" aria-hidden="true"></i>
                      View Reason
                    </button>
                    <!-- <button
                      v-if="isShowContactEarliestbtn"
                      type="button"
                      class="btn btn-outline-brand-1 mb-3 w-100">
                      <i class="fa fa-phone" aria-hidden="true"></i>
                      Contact Them Earliest
                    </button> -->
                    <button
                      v-if="
                        mydetail.is_membership_subscribed == 'Y' &&
                        isShowAcceptAgainbtn
                      "
                      v-on:click="accept()"
                      type="button"
                      class="btn btn-outline-brand-1 mb-3 w-100">
                      <i class="fa fa-check" aria-hidden="true"></i>Accept Again
                    </button>
                    <button
                      v-if="
                        mydetail.is_membership_subscribed == 'Y' &&
                        isShowAcceptRejectbtn
                      "
                      v-on:click="accept()"
                      type="button"
                      class="btn btn-outline-brand-1 mb-3 w-100">
                      <i class="fa fa-check" aria-hidden="true"></i>Accept
                    </button>
                    <button
                      v-if="
                        mydetail.is_membership_subscribed == 'Y' &&
                        isShowAcceptRejectbtn
                      "
                      v-on:click="showRejectpopup()"
                      type="button"
                      class="btn btn-outline-brand-1 mb-3 w-100">
                      <i class="fa fa-times" aria-hidden="true"></i>
                      Reject
                    </button>
                    <button
                      v-if="isShowDownloadProfile"
                      type="button"
                      class="btn btn-outline-brand-1 mb-3 w-100"
                      v-on:click="downloadProfile()">
                      <i
                        class="fa fa-download font-20 me-2"
                        aria-hidden="true"></i>
                      Download Profile
                    </button>
                    <button
                      v-if="
                        detail.is_send_reminder == 0 &&
                        isShowSendReminderbtn &&
                        detail.hasSentIntrest &&
                        isShowSendIntrest
                      "
                      :disabled="
                        detail.diffInHours < 24 || detail.is_send_reminder == 1
                      "
                      v-on:click="sendReminder()"
                      type="button"
                      class="btn btn-outline-brand-1 mb-3 w-100">
                      <i class="fa fa-bell" aria-hidden="true"></i>
                      Send Reminder
                    </button>
                    <button
                      v-if="
                        detail.is_send_reminder == 1 && isShowSendReminderbtn
                      "
                      :disabled="
                        detail.diffInHours < 24 || detail.is_send_reminder == 1
                      "
                      type="button"
                      class="btn btn-brand-1 mt-2 mb-3 w-100">
                      <i class="fa fa-bell" aria-hidden="true"></i>
                      Reminder Sent
                    </button>
                    <div v-click-outside="showDropDown" class="dropdown">
                      <button
                        v-if="isShowMorebtn"
                        type="button"
                        :class="
                          detail.hasBlocked || detail.hasReported
                            ? 'btn-brand-1'
                            : 'btn-outline-brand-1'
                        "
                        class="btn w-100 dropdown-toggle"
                        id="dropdownMore"
                        @click="
                          this.isClick = true;
                          this.isShowMore = !this.isShowMore;
                        ">
                        <i
                          class="fa fa-ellipsis-v font-20 me-2"
                          aria-hidden="true"></i>
                        More
                      </button>
                      <ul
                        :class="
                          isShowMore == true
                            ? 'dropdown-menu show'
                            : 'dropdown-menu'
                        ">
                        <li>
                          <a
                            class="dropdown-item cursor-pointer"
                            v-on:click="showSharePopup(detail.uuid)"
                            ><i class="fa fa-share-alt" aria-hidden="true"></i>
                            Share Profile</a
                          >
                        </li>
                        <li v-if="!detail.hasBlocked && !isShowUnblockbtn">
                          <a
                            class="dropdown-item cursor-pointer"
                            v-if="!detail.hasBlocked"
                            v-on:click="blockUser()"
                            ><i class="fa fa-ban" aria-hidden="true"></i> Block
                            User</a
                          >
                        </li>
                        <li v-if="detail.hasBlocked && !isShowUnblockbtn">
                          <a
                            class="dropdown-item cursor-pointer"
                            v-on:click="unblockUser()"
                            ><i class="fa fa-ban" aria-hidden="true"></i>
                            Unblock</a
                          >
                        </li>
                        <li>
                          <a
                            v-if="detail.hasReported == 0 && !isShowReasonbtn"
                            class="dropdown-item cursor-pointer"
                            v-on:click="showReportUser()"
                            ><i class="fa fa-flag" aria-hidden="true"></i>
                            Report This User</a
                          >
                          <a
                            v-if="detail.hasReported && !isShowReasonbtn"
                            class="dropdown-item cursor-pointer"
                            style="color: red; font-weight: 401"
                            ><i
                              class="fa fa-flag"
                              aria-hidden="true"
                              style="color: red"></i>
                            Already Reported</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-9 position-relative">
                    <nav
                      style="display: none"
                      id="navbar_scrolltab"
                      class="navbar navbar-light bg-white p-0 fixed-scroll-tab">
                      <ul class="nav nav-pills mb-3 tab-style-1 w-100">
                        <li class="nav-item">
                          <a class="nav-link" href="#ScrollSec_1"
                            >Personal details</a
                          >
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" href="#ScrollSec_2"
                            >Family details</a
                          >
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" href="#ScrollSec_3"
                            >Expectations</a
                          >
                        </li>
                      </ul>
                    </nav>

                    <div
                      data-bs-spy="scroll"
                      data-bs-target="#navbar_scrolltab"
                      data-bs-offset="90"
                      class="scrollspy-example form-style"
                      tabindex="0">
                      <h3 class="font-bold font-18 mb-3 gery-bar">
                        Personal Details
                      </h3>
                      <div class="row">
                        <div class="col-lg-6">
                          <div class="row">
                            <div class="col-lg-5">
                              <label>Registration No.</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.registration_no
                                    ? detail.registration_no
                                    : "-"
                                }}
                              </p>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-lg-5">
                              <label>Surname</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium pink-clr">
                                {{ detail.last_name ? detail.last_name : "-" }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-5">
                              <label>Marital Status</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.marital_status
                                    ? detail.marital_status.name
                                    : "-"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-5">
                              <label>Date of Birth</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.dob
                                    ? $helperService.getFormatedDate(detail.dob)
                                    : "-"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-5">
                              <label>Height</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.height
                                    ? $helperService.getHeight(detail.height)
                                    : "-"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-5">
                              <label>Body Structure</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.body_structure
                                    ? detail.body_structure.name
                                    : "-"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-5">
                              <label>Blood Group</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.blood_group ? detail.blood_group : "-"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-5">
                              <label>Skin Tone</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.scan_tone ? detail.scan_tone.name : "-"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-5">
                              <label>Diet</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{ detail.diet ? detail.diet.name : "-" }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-5">
                              <label>Education</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.education_courses
                                    ? detail.education_courses
                                    : "-"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-5">
                              <label>Gun Milan</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.patrika_gun >= 0 && type != "SELF"
                                    ? detail.patrika_gun
                                    : "NA"
                                }}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <div class="row">
                            <div class="col-lg-6">
                              <label>Occupational Details</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.occupation_details
                                    ? detail.occupation_details
                                    : "-"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-6">
                              <label>Annual Income (Lakh)</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.annual_income ||
                                  detail.annual_income == 0
                                    ? $helperService.kFormatter(
                                        detail.annual_income
                                      )
                                    : "-"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-6">
                              <label>Work Location</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.working_place_taluka
                                    ? detail.working_place_taluka.name
                                    : ""
                                }}
                                {{
                                  detail.working_place_taluka &&
                                  detail.working_place_taluka.name &&
                                  detail.working_place_goan &&
                                  mydetail.is_membership_subscribed == "Y"
                                    ? ", "
                                    : ""
                                }}
                              </p>

                              <p
                                class="font-medium"
                                v-show="
                                  mydetail.is_membership_subscribed == 'Y'
                                ">
                                {{
                                  detail.working_place_goan
                                    ? detail.working_place_goan
                                    : ""
                                }}
                              </p>
                              <p
                                v-if="
                                  !detail.working_place_goan &&
                                  !detail.working_place_taluka
                                ">
                                -
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-6">
                              <label>Other Information</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.other_info ? detail.other_info : "-"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-6">
                              <label>Birth Time & Birth District</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.birth_time
                                    ? $helperService.getFormatedTime(
                                        detail.birth_time
                                      )
                                    : "-"
                                }}
                                {{
                                  detail.birth_district
                                    ? detail.birth_district.name
                                    : "-"
                                }}
                              </p>
                            </div>
                          </div>

                          <!-- Family Details  -->
                          <div class="mb-4" id="ScrollSec_2">
                            <!-- <div class="row">
                          <div class="col-lg-4 col-md-5">
                            <label>Gun Milan</label>
                          </div>
                          <div class="col-lg-8 col-md-7">
                            <p class="font-medium">
                              {{ detail.gan ? detail.gan.name : "-" }}
                            </p>
                          </div>
                        </div> -->
                            <div class="row mt-3">
                              <div class="col-lg-6">
                                <label>Mangal</label>
                              </div>
                              <div class="col-lg-6">
                                <p class="font-medium">
                                  {{
                                    detail.is_mangal
                                      ? detail.is_mangal == "Y"
                                        ? "Yes"
                                        : detail.is_mangal == "N"
                                        ? "No"
                                        : $helperService.getTitleCase(
                                            detail.is_mangal.replaceAll(
                                              "_",
                                              " "
                                            )
                                          )
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-6">
                                <label>Horoscope Details</label>
                              </div>
                              <div class="col-lg-6">
                                <p class="font-medium">
                                  {{
                                    detail.raas && detail.raas.name
                                      ? detail.raas.name + ","
                                      : ""
                                  }}
                                  {{
                                    detail.nakshatra && detail.nakshatra.name
                                      ? detail.nakshatra.name + ","
                                      : ""
                                  }}
                                  {{
                                    detail.charan && detail.charan.name
                                      ? detail.charan.name + ","
                                      : ""
                                  }}
                                  {{
                                    detail.nadi && detail.nadi.name
                                      ? detail.nadi.name + ","
                                      : "-"
                                  }}

                                  {{
                                    detail.gan && detail.gan.name
                                      ? detail.gan.name
                                      : ""
                                  }}
                                </p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-6">
                                <label>Devak</label>
                              </div>
                              <div class="col-lg-6">
                                <p class="font-medium">
                                  {{ detail.devak ? detail.devak : "-" }}
                                </p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-6">
                                <label>Ready To move abroad</label>
                              </div>
                              <div class="col-lg-6">
                                <span class="font-medium">
                                  {{
                                    detail.ready_to_move_abrod &&
                                    detail.ready_to_move_abrod == "Y"
                                      ? "Yes"
                                      : detail.ready_to_move_abrod == "N"
                                      ? "No"
                                      : detail.ready_to_move_abrod ==
                                        "UNDECIDED"
                                      ? "Undecided"
                                      : detail.ready_to_move_abrod ==
                                        "ALREADY_IN"
                                      ? "Already In"
                                      : "-"
                                  }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <h3 class="font-bold font-18 mb-3 gery-bar mx-2">
                          Family Details
                        </h3>
                        <div class="">
                          <div class="row">
                            <div class="col-lg-3">
                              <label>Native Place</label>
                            </div>
                            <div class="col-lg-9">
                              <p class="font-medium">
                                <span
                                  class="font-regular"
                                  v-if="
                                    mydetail.is_membership_subscribed == 'Y'
                                  "
                                  >Gaon:</span
                                >&nbsp;
                                <span
                                  class="me-3"
                                  v-if="
                                    mydetail.is_membership_subscribed == 'Y'
                                  ">
                                  {{
                                    detail.native_place_goan
                                      ? detail.native_place_goan
                                      : "-"
                                  }}
                                </span>
                                <span
                                  class="font-regular"
                                  v-if="
                                    mydetail.is_membership_subscribed == 'Y'
                                  "
                                  >Taluka:</span
                                >&nbsp;
                                <span
                                  class="me-3"
                                  v-if="
                                    mydetail.is_membership_subscribed == 'Y'
                                  ">
                                  {{
                                    detail.native_place_taluka
                                      ? detail.native_place_taluka.name
                                      : "-"
                                  }}
                                </span>
                                <span class="font-regular">Dist.:</span>&nbsp;
                                <span class="">
                                  {{
                                    detail.native_place_district
                                      ? detail.native_place_district.name
                                      : "-"
                                  }}
                                </span>
                              </p>
                            </div>
                          </div>
                          <div class="col-lg-4 col-md-5" style="display: none">
                            <label>Family Residence</label>
                          </div>
                          <div class="col-lg-8 col-md-7" style="display: none">
                            <p class="font-medium">
                              <span class="me-3">
                                {{
                                  detail.family_details &&
                                  detail.family_details.goan
                                    ? detail.family_details.goan
                                    : "-"
                                }}
                                <span class="font-regular">Gaon</span></span
                              >
                              <span class="me-3">
                                {{
                                  detail.family_details &&
                                  detail.family_details.taluka
                                    ? detail.family_details.taluka.name
                                    : "-"
                                }}
                                <span class="font-regular">Taluka</span></span
                              >
                              <span class="">
                                {{
                                  detail.family_details &&
                                  detail.family_details.district
                                    ? detail.family_details.district.name
                                    : "-"
                                }}
                                <span class="font-regular">Dist.</span></span
                              >
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-3">
                            <label>Father Occupation</label>
                          </div>
                          <div class="col-lg-9">
                            <p class="font-medium">
                              <span class="me-3">{{
                                detail.family_details &&
                                detail.family_details.father_occuption
                                  ? detail.family_details.father_occuption
                                  : "-"
                              }}</span>
                              <span
                                class=""
                                v-show="
                                  mydetail.is_membership_subscribed == 'Y'
                                ">
                                {{
                                  detail.family_details &&
                                  detail.family_details.father_occuption_place
                                    ? detail.family_details
                                        .father_occuption_place
                                    : ""
                                }}</span
                              >
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-3">
                            <label>Mother Occupation</label>
                          </div>
                          <div class="col-lg-9">
                            <p class="font-medium">
                              <span class="me-3">
                                {{
                                  detail.family_details &&
                                  detail.family_details.mother_occuption
                                    ? detail.family_details.mother_occuption
                                    : "-"
                                }}</span
                              >
                              <span
                                class=""
                                v-show="
                                  mydetail.is_membership_subscribed == 'Y'
                                ">
                                {{
                                  detail.family_details &&
                                  detail.family_details.mother_occuption_place
                                    ? detail.family_details
                                        .mother_occuption_place
                                    : ""
                                }}</span
                              >
                            </p>
                          </div>
                        </div>
                        <div
                          class="row"
                          v-show="mydetail.is_membership_subscribed == 'Y'">
                          <div class="col-lg-4 col-md-5 mb-3">
                            <label class="font-bold"
                              >Brother/Sister Details</label
                            >
                          </div>
                          <!-- <div class="col-lg-8 col-md-7">
                          <p class="">
                            (If sister is married, mention surname only)
                          </p>
                        </div> -->
                        </div>
                        <div
                          class="table-wrap mb-3 table-responsive px-0"
                          v-show="mydetail.is_membership_subscribed == 'Y'">
                          <table
                            class="table table-style-1 table-responsive table-striped table-hover text-center"
                            id="sorting_tbl">
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Married?</th>
                                <th>Education</th>
                                <th>Occup.</th>

                                <th>Place</th>
                                <th>Birth Year</th>
                                <th>Hgt</th>
                                <th>Rel.</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(data, index) in detail.family_members"
                                :key="index">
                                <td>{{ data.name ? data.name : "-" }}</td>
                                <td>
                                  {{
                                    data.is_married
                                      ? data.is_married == "Y"
                                        ? "Yes"
                                        : "No"
                                      : "-"
                                  }}
                                </td>
                                <td>
                                  {{ data.education ? data.education : "-" }}
                                </td>
                                <td>
                                  {{ data.occupation ? data.occupation : "-" }}
                                </td>

                                <td>
                                  {{
                                    data.working_place
                                      ? data.working_place
                                      : "-"
                                  }}
                                </td>
                                <td>
                                  {{ data.birth_year ? data.birth_year : "-" }}
                                </td>
                                <td>
                                  {{
                                    data.height
                                      ? $helperService.getHeight(data.height)
                                      : "-"
                                  }}
                                </td>
                                <td>
                                  {{
                                    data.gender
                                      ? data.gender == "M"
                                        ? "Bro"
                                        : "Sis"
                                      : "-"
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="row">
                          <div class="col-lg-3">
                            <label class="">Mama’s Surname</label>
                          </div>
                          <div class="col-lg-9">
                            <p class="font-medium">
                              <span class="me-4">{{
                                detail.family_details &&
                                detail.family_details.mama_surname
                                  ? detail.family_details.mama_surname
                                  : "-"
                              }}</span>
                              <span
                                class="me-4 font-regular"
                                v-show="
                                  mydetail.is_membership_subscribed == 'Y'
                                ">
                                <span
                                  v-if="
                                    detail.family_details &&
                                    detail.family_details.mama_native_place
                                  ">
                                  Native Gaon
                                </span>
                                <span class="font-medium">{{
                                  detail.family_details &&
                                  detail.family_details.mama_native_place
                                    ? detail.family_details.mama_native_place
                                    : " "
                                }}</span></span
                              >
                              <span
                                class="font-regular"
                                v-if="
                                  detail.family_details &&
                                  detail.family_details.mama_taluka_place
                                ">
                                Taluka
                                <span class="font-medium">{{
                                  detail.family_details &&
                                  detail.family_details.mama_taluka_place
                                    ? detail.family_details.mama_taluka_place
                                    : ""
                                }}</span></span
                              >
                            </p>
                          </div>
                        </div>

                        <!-- style="max-height: 150px; overflow: scroll" -->
                        <div class="row">
                          <div class="col-lg-3">
                            <label class="">Relatives </label>
                          </div>
                          <div class="col-lg-9">
                            <div>
                              <span
                                v-for="(data, index) in detail.relatives"
                                :key="index">
                                <p
                                  v-if="data.surname || data.goan"
                                  class="font-medium">
                                  <span
                                    v-if="detail.relative.length > 0"
                                    class="me-4">
                                    {{ data.surname ? data.surname : "" }}
                                    <span
                                      class="font-medium"
                                      v-show="
                                        mydetail.is_membership_subscribed == 'Y'
                                      ">
                                      {{
                                        data.goan ? " - " + data.goan : ""
                                      }}</span
                                    ></span
                                  >
                                </p>
                              </span>
                            </div>
                            <p
                              class="font-medium"
                              v-if="detail.relative.length == 0">
                              -
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="mb-4" id="ScrollSec_3">
                        <div class="row">
                          <div class="col-lg-3">
                            <label class="">Properties </label>
                          </div>
                          <div class="col-lg-9">
                            <span
                              v-for="(data, index) in detail.properties"
                              :key="index">
                              <p
                                v-if="data.details || data.place"
                                class="font-medium">
                                <span
                                  v-if="detail.properties.length > 0"
                                  class="">
                                  {{ data.details ? data.details : "" }}
                                  <span
                                    class="font-mediumr"
                                    v-show="
                                      mydetail.is_membership_subscribed == 'Y'
                                    ">
                                    {{
                                      data.place ? " - " + data.place : ""
                                    }}</span
                                  ></span
                                >
                              </p>
                            </span>
                            <p
                              class="font-medium"
                              v-if="detail.properties.length == 0">
                              -
                            </p>
                          </div>
                        </div>
                        <h3 class="font-bold font-18 mb-3 gery-bar">
                          Expectations
                        </h3>
                        <div class="row mb-2">
                          <div class="col-lg-3">
                            <label> Marital Status</label>
                          </div>
                          <div class="col-lg-9">
                            <p class="font-medium" v-if="!detail.expectation">
                              -
                            </p>
                            <p class="font-medium">{{ marrital_status }}</p>
                          </div>
                        </div>
                        <!-- <div class="row">
                          <div class="col-lg-4 col-md-6">
                            <label>Expected Body Structure</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium">{{ body_structure }}</p>
                          </div>
                        </div> -->
                        <!-- <div class="row">
                          <div class="col-lg-4 col-md-6">
                            <label>Expected Diet</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium">{{ diet }}</p>
                          </div>
                        </div> -->

                        <!-- <div class="row">
                          <div class="col-lg-4 col-md-6">
                            <label>Occupation</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium">{{ occupation_type }}</p>
                          </div>
                        </div> -->

                        <div class="row mb-2">
                          <div class="col-lg-3">
                            <label> Birth Years</label>
                          </div>

                          <div class="col-lg-9">
                            <p class="font-medium">
                              {{
                                detail.expectation &&
                                detail.expectation.birth_year_from
                                  ? detail.expectation.birth_year_from + " to "
                                  : ""
                              }}

                              {{
                                detail.expectation &&
                                detail.expectation.birth_year_to
                                  ? detail.expectation.birth_year_to
                                  : "-"
                              }}
                            </p>
                            <!-- <p class="font-medium" v-if="!detail.expectation">-</p> -->
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-lg-3">
                            <label> Height</label>
                          </div>
                          <div class="col-lg-9" v-if="!detail.expectation">
                            <p class="font-medium" v-if="!detail.expectation">
                              -
                            </p>
                          </div>
                          <div
                            class="col-lg-8 col-md-6"
                            v-if="detail.expectation">
                            <p class="font-medium">
                              {{
                                $helperService.getHeight(
                                  detail.expectation.height_from
                                )
                                  ? $helperService.getHeight(
                                      detail.expectation.height_from
                                    ) + "- " // detail.expectation.height_from + // " cm to "
                                  : "- "
                              }}

                              {{
                                $helperService.getHeight(
                                  detail.expectation.height_to
                                )
                                  ? $helperService.getHeight(
                                      detail.expectation.height_to
                                    ) // ) + // "- " + // detail.expectation.height_to + // " cm"
                                  : ""
                              }}
                            </p>
                            <p class="font-medium" v-if="!detail.expectation">
                              -
                            </p>
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-lg-3">
                            <label>Patrika Matching</label>
                          </div>
                          <div class="col-lg-9">
                            <p class="font-medium" v-if="!detail.expectation">
                              -
                            </p>
                            <p class="font-medium">
                              {{
                                detail.expectation &&
                                detail.expectation.patrika_match == "Y"
                                  ? "YES"
                                  : detail.expectation &&
                                    detail.expectation.patrika_match == "ALL"
                                  ? "Flexible"
                                  : detail.expectation &&
                                    detail.expectation.patrika_match == "N"
                                  ? "NO"
                                  : "-"
                              }}
                            </p>
                          </div>
                        </div>
                        <!-- <div class="row mb-2">
                          <div class="col-lg-4 col-md-6">
                            <label>Preferred Working Cities</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium">
                              {{ working_city_name ? working_city_name : "-" }}
                              {{ working_country_name }}
                            </p>
                            <p class="font-medium" v-if="!detail.expectation">
                              -
                            </p>
                          </div>
                        </div> -->
                        <!-- <div class="row mb-2">
                          <div class="col-lg-4 col-md-6">
                            <label>Preferred Native Places</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium" v-if="!detail.expectation">
                              -
                            </p>
                            <p class="font-medium">
                              {{ native_district ? native_district : "-" }}
                            </p>
                          </div>
                        </div> -->
                        <!-- <div class="row">
                          <div class="col-lg-4 col-md-6">
                            <label>Family Residencial Taluka</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium">
                              {{ family_residence }}
                            </p>
                          </div>
                        </div> -->
                        <!-- <div class="row">
                          <div class="col-lg-4 col-md-6">
                            <label>Education Group</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium">{{ education_group }}</p>
                          </div>
                        </div> -->
                        <!-- <div class="row">
                          <div class="col-lg-4 col-md-6">
                            <label>Move to Abroad</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium">{{ move_to_abroad }}</p>
                          </div>
                        </div> -->
                        <!-- <div class="row">
                          <div class="col-lg-4 col-md-6">
                            <label>Per.</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium">{{ personality }}</p>
                          </div>
                        </div> -->
                        <!-- <div class="row">
                          <div class="col-lg-4 col-md-6">
                            <label>Echo Status</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium">{{ echo_status }}</p>
                          </div>
                        </div> -->
                        <!-- <div class="row">
                          <div class="col-lg-4 col-md-6">
                            <label>Relation</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium">{{ relation }}</p>
                          </div>
                        </div> -->
                        <!-- <div class="row mb-3">
                          <div class="col-lg-4 col-md-6">
                            <label>Expected Education</label>
                          </div>
                          <div
                            class="col-lg-8 col-md-6"
                            v-if="!detail.expectation"
                          >
                            <p class="font-medium" v-if="!detail.expectation">
                              -
                            </p>
                          </div>
                          <div
                            class="col-lg-8 col-md-6"
                            v-if="detail.expectation"
                          >
                            <p class="font-medium">
                              {{
                                detail.expectation.expected_educations
                                  ? detail.expectation.expected_educations
                                  : "-"
                              }}
                            </p>
                          </div>
                        </div> -->
                        <div class="row mb-2">
                          <div class="col-lg-3">
                            <label>Expectations</label>
                          </div>
                          <div class="col-lg-9" v-if="!detail.expectation">
                            <p class="font-medium">-</p>
                          </div>
                          <div
                            class="col-lg-8 col-md-6"
                            v-if="detail.expectation">
                            <p class="font-medium">
                              {{
                                detail.expectation.occupation_other_expectations
                                  ? detail.expectation
                                      .occupation_other_expectations
                                  : "-"
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="text-center" style="min-height: 21vh">
            <div v-if="!loader">
              <h2>User Not Found</h2>
            </div>
          </div>
          <ErrorComponent @retry="getUserDetail()" ref="errorComponent" />
        </div>
      </div>
    </main>
    <MainFooter />

    <ImageGalleryModel ref="galleryModel">
      <div
        class="modal-dialog photos-gallery modal-dialog-centered"
        style="max-width: 500px">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="btn-close bg-light"
              v-on:click="$refs.galleryModel.closeModal()"></button>
          </div>
          <div class="modal-body">
            <div>
              <div class="text-center">
                <img
                  v-if="selected_image"
                  style="width: 100%; object-fit: contain; height: 380px"
                  id="preview"
                  :src="selected_image"
                  width="1000"
                  height="800" />
              </div>
            </div>
            <div class="image-gallary d-flex">
              <div
                class="col-2 me-2"
                v-for="(data, index) in detail.user_images"
                :key="index">
                <div v-if="data.image" v-on:click="changeImage(data.image)">
                  <img :src="data.image" width="50" height="50" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ImageGalleryModel>
    <TextModal ref="reportModal">
      <div class="modal-content">
        <div class="modal-header px-md-5 border-0">
          <div class="row">
            <!-- <h5 class="modal-title" id="loginModalLabel">Report</h5> -->
            <button
              type="button"
              class="btn-close"
              v-on:click="$refs.reportModal.closeModal()"></button>
          </div>
        </div>
        <div class="modal-body px-4">
          <h5 class="modal-title font-22 mb-0 text-center mb-3">Report</h5>
          <Form ref="reportForm" @submit="reportUser()">
            <div class="floating-form mb-4">
              <div class="floating-form-group mt-4 mb-2" style="height: 130px">
                <Field
                  as="textarea"
                  type="text"
                  rows="4"
                  style="width: 100%"
                  name="message"
                  rules="required:message"
                  :validateOnInput="true"
                  v-model="reportObj.message" />

                <label for="message"
                  >Please write your problem/suggestion</label
                >
                <span class="text-danger">*</span>
              </div>
              <ErrorMessage name="message" class="text-danger" />
            </div>
            <div class="text-center">
              <button class="btn btn-brand-1" id="submit-Button11">
                Submit
              </button>
            </div>
          </Form>
        </div>
      </div>
    </TextModal>
    <TextModal ref="viewMembershipPlan">
      <div>
        <div class="row col-12 px-md-5 border-0 p-4 text-align-last-center">
          <div class="col-1" style="text-align-last: end"></div>
        </div>
        <div class="modal-body pt-0 form-style">
          <div class="row">
            <button
              type="button"
              class="btn-close"
              style="margin-left: auto; margin-top: -58px; margin-right: -10px"
              v-on:click="$refs.viewMembershipPlan.closeModal()"></button>
          </div>
          <div class="form-group">
            <h4 class="text-center">You are a free member</h4>
            <p>
              Buy a paid membership to see contact no. & some hidden information
            </p>
          </div>
          <div class="text-center">
            <router-link
              to="/membership-plans"
              class="btn btn-brand-1 btn-block">
              View membership plan
            </router-link>
          </div>
        </div>
      </div>
    </TextModal>
    <TextModal ref="remainingContacts">
      <div>
        <div class="row border-0 text-align-last-center">
          <div class="col-1" style="text-align-last: end"></div>
        </div>
        <div class="modal-body pt-0 form-style">
          <div class="row">
            <button
              type="button"
              class="btn-close"
              style="margin-left: auto"
              v-on:click="$refs.remainingContacts.closeModal()"></button>
          </div>
          <div class="form-group">
            <h4 class="text-center">View Contact</h4>
            <p>
              Your Total Remaining Contact View is -
              {{ remaining_contact_view_count }}
            </p>
          </div>
          <div class="text-center">
            <button
              type="button"
              class="btn btn-brand-1 w-100 mb-3"
              v-on:click="showContactModel()">
              View Contact
            </button>
          </div>
        </div>
      </div>
    </TextModal>
    <TextModal ref="invalidlink">
      <div>
        <div class="row col-12 px-md-5 border-0 p-4 text-align-last-center">
          <div class="col-1" style="text-align-last: end"></div>
        </div>
        <div class="modal-body pt-0 form-style">
          <div class="row">
            <button
              type="button"
              class="btn-close"
              style="margin-left: auto; margin-top: -58px; margin-right: -10px"
              v-on:click="$refs.invalidlink.closeModal()"></button>
          </div>
          <div class="form-group">
            <h4 class="text-center">
              Sorry, you cannot access same gender's biodata
            </h4>
            <!-- <p></p> -->
          </div>
          <!-- <div class="text-center">
            <router-link
              to="/membership-plans"
              class="btn btn-brand-1 btn-block"
            >
              View membership plan
            </router-link>
          </div> -->
        </div>
      </div>
    </TextModal>
    <TextModal ref="ViewrejectMessageModal">
      <div class="modal-content">
        <div class="modal-header px-md-5 border-0">
          <div class="row">
            <!-- <h5 class="modal-title" id="loginModalLabel">Report</h5> -->
            <button
              type="button"
              class="btn-close"
              v-on:click="$refs.ViewrejectMessageModal.closeModal()"></button>
          </div>
        </div>
        <div class="modal-body px-4">
          <h5 class="modal-title font-22 mb-0 text-center mb-3">
            Rejection Reason
          </h5>
          <Form ref="rejectIntrestForm">
            <div class="floating-form mb-4">
              <div class="floating-form-group mt-4 mb-2" style="height: 130px">
                <Field
                  as="textarea"
                  type="text"
                  rows="4"
                  disabled
                  style="width: 100%"
                  name="message1"
                  rules="required:message"
                  :validateOnInput="true"
                  v-model="message" />

                <!-- <label for="message"
                  >Please write your problem/suggestion</label
                >
                <span class="text-danger">*</span> -->
              </div>
              <!-- <ErrorMessage name="message" class="text-danger" /> -->
            </div>
            <!-- <div class="text-center">
              <button class="btn btn-brand-1" id="submit-button7">Submit</button>
            </div> -->
          </Form>
        </div>
      </div>
    </TextModal>
    <TextModal ref="rejectIntrestModal">
      <div class="modal-content">
        <div class="modal-header px-md-5 border-0">
          <div class="row">
            <!-- <h5 class="modal-title" id="loginModalLabel">Report</h5> -->
            <button
              type="button"
              class="btn-close"
              v-on:click="$refs.rejectIntrestModal.closeModal()"></button>
          </div>
        </div>
        <div class="modal-body px-4">
          <h5 class="modal-title font-22 mb-0 text-center mb-3">
            Rejection Reason
          </h5>
          <Form ref="rejectIntrestForm" @submit="reject()">
            <div class="floating-form mb-4">
              <div class="floating-form-group mt-4 mb-2" style="height: 130px">
                <Field
                  as="textarea"
                  type="text"
                  rows="4"
                  style="width: 100%"
                  name="message"
                  rules="required:message"
                  :validateOnInput="true"
                  v-model="rejectObj.message" />

                <!-- <label for="message"
                  >Please write your problem/suggestion</label
                > -->
                <!-- <span class="text-danger">*</span> -->
              </div>
              <ErrorMessage name="message" class="text-danger" />
            </div>
            <div class="text-center">
              <button class="btn btn-brand-1" id="submit-button">Submit</button>
            </div>
          </Form>
        </div>
      </div>
    </TextModal>
    <ShareModal ref="shareModal" />
    <ConteactViewModel ref="ConteactViewModel" />
  </div>
</template>
<script>
import ErrorComponent from "@/components/ErrorComponent";
import ConteactViewModel from "@/components/ConteactViewModel";
import TextModal from "@/components/TextModal.vue";
import ImageGalleryModel from "@/components/ImageGalleryModel.vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import ShareModal from "@/views/SocialShare/ShareModal.vue";
export default {
  name: "HandpickSuggestions",
  components: {
    ErrorComponent,
    ConteactViewModel,
    TextModal,
    ImageGalleryModel,
    Form,
    Field,
    ErrorMessage,
    ShareModal,
  },
  data() {
    return {
      uuid: this.$route.params.uuid,
      type: this.$route.params.type,
      tab_type: this.$route.params.tab_type,
      activity_id: this.$route.params.activity_id,
      gender: localStorage.getItem("gender"),
      loader: false,
      isClick: false,
      isShowMore: false,
      detail: {
        user_images: [],
        expectation: {
          marital_status: [],
          family_members: [],
        },
      },
      selected_image: "",
      remaining_contact_view_count: 0,
      mydetail: {},
      contentDetail: {},
      indexCount: 1,
      report_id: "",
      message: "",
      reportObj: {},
      marrital_status: "",
      working_country_name: "",
      family_residence: "",
      working_country: "",
      native_district: "",
      working_city_name: "",
      url: window.location.href,
      count: "",
      showingFullText: false,
      showingFullIngredients: false,
      ingredients: "",
      isShowContactView: true,
      isShowSendIntrest: false,
      isShowShortListed: false,
      isShowDownloadProfile: false,
      isShowMorebtn: false,
      isShowAcceptRejectbtn: false,
      isShowAcceptAgainbtn: false,
      isShowSendReminderbtn: false,
      isShowContactEarliestbtn: false,
      isShowUnblockbtn: false,
      isShowReasonbtn: false,
      rejectObj: {
        uuid: "",
        message: "",
      },
    };
  },
  mounted() {
    this.getMeCall();
    if (window.history.state?.back == "/shortlisted") {
      this.isShowSendIntrest = true;
      this.isShowShortListed = true;
    } else if (window.history.state?.back == "/intrest-sent") {
      if (this.tab_type == "PENDING") {
        this.isShowSendIntrest = true;
        this.isShowSendReminderbtn = true;
      } else if (this.tab_type == "ACCEPTED") {
        this.isShowSendIntrest = false;
        this.isShowDownloadProfile = true;
        this.isShowContactEarliestbtn = false;
      } else if (this.tab_type == "REJECTED") {
        this.isShowContactView = false;
        this.isShowReasonbtn = true;
      }
    } else if (window.history.state?.back == "/intrest-recieved") {
      if (this.tab_type == "PENDING") {
        this.isShowAcceptRejectbtn = true;
      } else if (this.tab_type == "ACCEPTED") {
        this.isShowDownloadProfile = true;
        this.isShowContactEarliestbtn = true;
      } else if (this.tab_type == "REJECTED") {
        this.isShowContactView = false;
        this.isShowAcceptAgainbtn = true;
        this.isShowReasonbtn = true;
      }
    } else if (window.history.state?.back == "/blocked-users") {
      this.isShowSendIntrest = true;
      this.isShowShortListed = true;
      this.isShowMorebtn = true;
      this.isShowUnblockbtn = true;
    } else if (window.history.state?.back == "/reported-users") {
      this.isShowSendIntrest = true;
      this.isShowShortListed = true;
      this.isShowMorebtn = true;
      this.isShowReasonbtn = true;
    } else {
      this.isShowShortListed = true;
      this.isShowSendIntrest = true;
      this.isShowMorebtn = true;
    }
    if (this.uuid) {
      this.getUserDetail();
    }
    window.scrollTo(0, 4);
  },
  methods: {
    changeImage(image) {
      this.selected_image = "";
      this.selected_image = image;
      document.getElementById("preview").src = image;
    },
    sendReminder() {
      var obj = {};
      obj.to_user_id = this.uuid;
      this.$api
        .postAPI({
          _action: "/send-reminder",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.detail.is_send_reminder = 1;
        })
        .catch(() => {});
    },
    reject() {
      if (this.rejectObj.uuid) {
        this.$api
          .putAPI({
            _action: "/intrest-reject",
            _body: this.rejectObj,
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.isShowAcceptRejectbtn = false;
            this.isShowContactView = false;
            this.isShowAcceptAgainbtn = true;
            this.$refs.rejectIntrestModal.closeModal();
          })
          .catch(() => {});
      } else {
        return;
      }
    },
    showRejectpopup() {
      if (this.mydetail.is_membership_subscribed != "Y") {
        this.$notify({
          type: "error",
          text: "To Accept or Reject interest, you have to purchase subscription plan",
        });
        return;
      }
      this.$refs.rejectIntrestForm.resetForm();
      if (this.activity_id) {
        this.rejectObj.uuid = this.activity_id;
      }
      this.$refs.rejectIntrestModal.showModal();
    },
    accept() {
      if (this.mydetail.is_membership_subscribed != "Y") {
        this.$notify({
          type: "error",
          text: "To Accept or Reject interest, you have to purchase subscription plan",
        });
        return;
      }
      var obj = {};
      obj.uuid = this.activity_id ? this.activity_id : "";
      if (obj.uuid) {
        this.$api
          .putAPI({
            _action: "/intrest-accept",
            _body: obj,
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.isShowAcceptRejectbtn = false;
            this.isShowDownloadProfile = true;
            this.isShowContactEarliestbtn = true;
          })
          .catch(() => {});
      } else {
        return;
      }
    },
    showDropDown() {
      if (this.isClick) {
        this.isClick = false;
      } else {
        this.isShowMore = false;
      }
    },
    showViewReportedReasonpopup() {
      this.message = this.detail.message;
      this.$refs.ViewrejectMessageModal.showModal();
    },
    showViewRejectpopup() {
      this.message = this.detail.message_new;
      this.$refs.ViewrejectMessageModal.showModal();
    },
    downloadProfile() {
      var url = this.$api.getBaseUrl() + "get/biodata?uuid=" + this.uuid + "&from_uuid=" + this.mydetail.uuid;
      window.open(url);
    },
    showSharePopup(uuid) {
      var url = this.url.replaceAll(
        "/handpick-suggestions",
        "/profile-view/" + uuid
      );
      this.url = url;
      this.$refs.shareModal.showModal(this.url, "Profile");
    },
    getUserDetail() {
      this.loader = true;
      if (this.$refs.errorComponent) {
        this.$refs.errorComponent.updateListLoader(true);
      }
      var obj = {};
      if (this.activity_id) {
        obj.activity_id = this.activity_id;
      }
      this.$api
        .getAPI({
          _action: "/profile-detail/" + this.uuid,
          _body: obj,
        })
        .then((res) => {
          this.loader = false;
          if (this.type != "SELF" && res.gender == this.gender) {
            if (this.$refs.errorComponent) {
              this.$refs.errorComponent.updateListLoader(false);
            }
            this.$refs.invalidlink.showModal();
            return;
          }
          this.detail = res;
          if (this.detail.is_there == true) {
            this.isShowAcceptRejectbtn = true;
            this.isShowSendIntrest = false;
            this.activity_id = this.detail.activity_id;
          }
          if (this.detail.hasSentIntrest == 1) {
            if (this.detail.SentIntrestStatus == "PENDING") {
              this.isShowSendIntrest = true;
            } else {
              this.isShowSendIntrest = false;
            }
          }
          if (this.detail.hasRecivedIntrest == 1) {
            if (this.detail.RecivedIntrestStatus == "PENDING") {
              this.isShowSendIntrest = false;
            } else {
              this.isShowSendIntrest = false;
            }
          }
          if (!this.detail.hasBlocked) {
            this.isShowUnblockbtn = false;
          }

          if (
            this.detail.expectation &&
            this.detail.expectation.marital_status.length > 0
          ) {
            var array = [];
            for (var i in this.detail.expectation.marital_status) {
              array.push(` ${this.detail.expectation.marital_status[i].name}`);
            }
            this.marrital_status = array.toString();
          }
          // if (
          //   this.detail.expectation &&
          //   this.detail.expectation.occupation_type.length > 0
          // ) {
          //   var array_1 = [];
          //   for (var j in this.detail.expectation.occupation_type) {
          //     array_1.push(
          //       ` ${this.detail.expectation.occupation_type[j].name}`
          //     );
          //   }
          //   this.occupation_type = array_1.toString();
          // }

          // if (
          //   this.detail.expectation &&
          //   this.detail.expectation.echo_status.length > 0
          // ) {
          //   var array_2 = [];
          //   for (var k in this.detail.expectation.echo_status) {
          //     array_2.push(` ${this.detail.expectation.echo_status[k].name}`);
          //   }
          //   this.echo_status = array_2.toString();
          // }

          // if (
          //   this.detail.expectation &&
          //   this.detail.expectation.relation.length > 0
          // ) {
          //   var array_3 = [];
          //   for (var l in this.detail.expectation.relation) {
          //     array_3.push(` ${this.detail.expectation.relation[l].name}`);
          //   }
          //   this.relation = array_3.toString();
          // }
          // if (
          //   this.detail.expectation &&
          //   this.detail.expectation.personality.length > 0
          // ) {
          //   var array_4 = [];
          //   for (var m in this.detail.expectation.personality) {
          //     array_4.push(` ${this.detail.expectation.personality[m].name}`);
          //   }
          //   this.personality = array_4.toString();
          // }
          // if (
          //   this.detail.expectation &&
          //   this.detail.expectation.education_group.length > 0
          // ) {
          //   var array_5 = [];
          //   for (var n in this.detail.expectation.education_group) {
          //     array_5.push(
          //       ` ${this.detail.expectation.education_group[n].name}`
          //     );
          //   }
          //   this.education_group = array_5.toString();
          // }
          if (
            this.detail.expectation &&
            this.detail.expectation.working_country.length > 0
          ) {
            var array_6 = [];
            for (var a in this.detail.expectation.working_country) {
              array_6.push(
                ` ${this.detail.expectation.working_country[a].name}`
              );
            }
            this.working_country_name = array_6.toString();
          }

          if (
            this.detail.expectation &&
            this.detail.expectation.working_city.length > 0
          ) {
            var array_7 = [];
            for (var b in this.detail.expectation.working_city) {
              array_7.push(` ${this.detail.expectation.working_city[b].name}`);
            }
            this.working_city_name = array_7.toString();
          }

          // if (
          //   this.detail.expectation &&
          //   this.detail.expectation.body_structure.length > 0
          // ) {
          //   var array_8 = [];
          //   for (var c in this.detail.expectation.body_structure) {
          //     array_8.push(
          //       ` ${this.detail.expectation.body_structure[c].name}`
          //     );
          //   }
          //   this.body_structure = array_8.toString();
          // }

          if (
            this.detail.expectation &&
            this.detail.expectation.family_residence.length > 0
          ) {
            var array_9 = [];
            for (var d in this.detail.expectation.family_residence) {
              array_9.push(
                ` ${this.detail.expectation.family_residence[d].name}`
              );
            }
            this.family_residence = array_9.toString();
          }

          if (
            this.detail.expectation &&
            this.detail.expectation.native_district.length > 0
          ) {
            var array_10 = [];
            for (var e in this.detail.expectation.native_district) {
              array_10.push(
                ` ${this.detail.expectation.native_district[e].name}`
              );
            }
            this.native_district = array_10.toString();
          }
          // if (
          //   this.detail.expectation &&
          //   this.detail.expectation.diet.length > 0
          // ) {
          //   var array_11 = [];
          //   for (var f in this.detail.expectation.diet) {
          //     array_11.push(` ${this.detail.expectation.diet[f].name}`);
          //   }
          //   this.diet = array_11.toString();
          // }
          // if (
          //   this.detail.expectation &&
          //   this.detail.expectation.move_to_abroad.length > 0
          // ) {
          //   var array_12 = [];
          //   for (var g in this.detail.expectation.move_to_abroad) {
          //     array_12.push(
          //       ` ${this.detail.expectation.move_to_abroad[g].name}`
          //     );
          //   }
          //   this.move_to_abroad = array_12.toString();
          // }
          if (this.$refs.errorComponent) {
            this.loader = false;
            //  this.$refs.errorComponent.setData(res, "User Not Found");
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          this.$refs.errorComponent.updateListLoader(false);
        });
    },
    smsEmailUserDetails(uuid) {
      this.$api
        .getAPI({
          _action: "/email-detail/" + uuid,
        })
        .then(() => {
          this.$notify({
            type: "success",
            text: "User details are successfully sent to your registered email and mobile number",
          });
          this.$refs.viewContactmodel.closeModal();
        })
        .catch(() => {});
    },
    getMeCall() {
      this.$api
        .getAPI({
          _action: "/user/me",
        })
        .then((res) => {
          this.mydetail = res;
          this.$store.commit("setUser", res);
          if (res.gender) {
            this.gender = res.gender;
            localStorage.setItem("gender", res.gender);
          }
        })
        .catch(() => {});
    },
    PrevIndex() {
      if (this.indexCount == 1) {
        this.indexCount = this.detail.user_images.length;
      } else {
        this.indexCount = this.indexCount - 1;
      }
    },
    NextIndex() {
      if (this.indexCount == this.detail.user_images.length) {
        this.indexCount = 1;
      } else {
        this.indexCount = this.indexCount + 1;
      }
    },
    shortlist() {
      var obj = {};
      if (this.detail) {
        obj.to_user_id = this.detail.uuid ? this.detail.uuid : "";
      } else {
        return;
      }
      if (obj.to_user_id) {
        this.$api
          .postAPI({
            _action: "/short-list",
            _body: obj,
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            return (this.detail.hasShortListed = 1);
          })
          .catch(() => {});
      }
    },
    unblockUserBtn() {
      if (this.uuid) {
        var obj = {};
        obj.to_user_id = this.uuid;
        this.$api
          .postAPI({
            _action: "/unblock-user",
            _body: obj,
          })
          .then((res) => {
            if (res) {
              this.$notify({
                type: "success",
                text: res.message,
              });
              this.isShowUnblockbtn = false;
              return (this.detail.hasBlocked = 0);
            }
          })
          .catch(() => {});
      }
    },
    sendIntrest() {
      var obj = {};
      obj.to_user_id = this.detail.uuid ? this.detail.uuid : "";
      this.$api
        .postAPI({
          _action: "/send-intrest",
          _body: obj,
        })
        .then((res) => {
          if (res.is_there == true) {
            this.isShowAcceptRejectbtn = true;
            this.isShowSendIntrest = false;
            this.activity_id = res.activity_id;
          } else {
            this.$notify({
              type: "success",
              text: res.message,
            });
            return (this.detail.hasSentIntrest = 1);
          }
        })
        .catch(() => {});
    },
    notIntrested() {
      var obj = {};
      obj.to_user_id = this.detail.uuid ? this.detail.uuid : "";
      this.$api
        .putAPI({
          _action: "/cancel-request/" + obj.to_user_id,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          return (this.detail.hasSentIntrest = 0);
        })
        .catch(() => {});
    },
    blockUser() {
      var obj = {};
      obj.to_user_id = this.detail.uuid ? this.detail.uuid : "";
      this.$api
        .postAPI({
          _action: "/block-user",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.isShowUnblockbtn = true;
          return (this.detail.hasBlocked = 1);
        })
        .catch(() => {});
    },
    unblockUser() {
      var obj = {};
      obj.to_user_id = this.detail.uuid ? this.detail.uuid : "";
      this.$api
        .postAPI({
          _action: "/unblock-user",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          return (this.detail.hasBlocked = 0);
        })
        .catch(() => {});
    },
    reportUser() {
      this.reportObj.to_user_id = this.report_id;
      this.$api
        .postAPI({
          _action: "/report-user",
          _body: this.reportObj,
          _buttonId: "submit-Button11",
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.detail.hasReported = 1;
          this.$refs.reportModal.closeModal();
          this.changeTab(this.currentTab);
        })
        .catch(() => {});
    },
    removeShortlisted() {
      var obj = {};
      if (this.detail) {
        obj.to_user_id = this.detail.uuid ? this.detail.uuid : "";
      } else {
        obj.to_user_id = this.detail.uuid ? this.detail.uuid : "";
      }
      if (obj.to_user_id) {
        this.$api
          .putAPI({
            _action: "/remove-shortlist/" + obj.to_user_id,
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            return (this.detail.hasShortListed = 0);
          })
          .catch(() => {});
      }
    },
    showReportUser() {
      this.report_id = this.detail.uuid;
      this.$refs.reportForm.resetForm();
      this.$refs.reportModal.showModal();
    },
    showUserGallery(index) {
      if (this.detail.user_images.length > 0) {
        this.selected_image = this.detail.user_images[index].image;
      }
      this.$refs.galleryModel.showModal();
    },

    showRemmaingtactModel(uuid) {
      this.$refs.errorComponent.updateFormLoader(true);
      if (uuid) {
        this.uuid = uuid;
      }
      this.$api
        .getAPI({
          _action: "/remmaing-contact-detail/" + this.uuid,
        })
        .then((res) => {
          this.$refs.errorComponent.updateFormLoader(false);
          if (res.contact_view && res.contact_view > 0) {
            this.remaining_contact_view_count = res.contact_view;
            this.$refs.remainingContacts.showModal();
          } else if (res.already_viewed && res.already_viewed == 1) {
            this.contentDetail = res;
            this.$refs.ConteactViewModel.showModal(this.contentDetail);
          } else {
            this.$refs.viewMembershipPlan.showModal();
          }
        })
        .catch(() => {
          this.$refs.errorComponent.updateFormLoader(false);
        });
    },
    showContactModel() {
      this.$refs.remainingContacts.closeModal();
      this.$api
        .getAPI({
          _action: "/contact-detail/" + this.uuid,
        })
        .then((res) => {
          if (res) {
            this.contentDetail = res;
            this.$refs.remainingContacts.closeModal();
            this.getUserDetail();
            this.$refs.ConteactViewModel.showModal(this.contentDetail);
          }
        })
        .catch(() => {});
    },
  },
};
</script>
<style>
.font-medium {
  word-wrap: break-word;
  word-break: break-all;
}
</style>
